<template>
  <a-modal
    v-model="show"
    :title="type === 1 ? $t('publish.addPanoramic') : (type === 2 ? $t('publish.addMer') : (type === 3 ? $t('publish.addTongPing') : $t('publish.addlive')))"
    :destroyOnClose="true" 
    :centered="true" 
    :maskClosable="false" 
    :width="850" 
    :footer="null"
    @cancel="handleCancel"
  >
    <!-- 全景圖片 -->
    <panoramic-list 
      v-if="type == 1"
      v-bind="$attrs" 
      ref="materialList" 
      :type="type" 
      @selected="handleSelected" 
      @showUpload="showUpload"
      @dirChange="onDirChange" 
    />
    <!-- 全景影片 -->
    <material-list 
      v-else-if="type == 2"
      v-bind="$attrs" 
      ref="materialList" 
      :type="type" 
      @selected="handleSelected" 
      @showUpload="showUpload"
      @dirChange="onDirChange" 
    />
    <!-- 全景列表 -->
    <scene-list 
      v-else-if="type == 3"
      ref="sceneList" 
      :type="type" 
      @selected="handleSelectScene" 
    />
    <!-- 全景直播 -->
    <live-list 
      v-else
      v-bind="$attrs" 
      ref="materialList" 
      :type="type" 
      @selected="handleSelected" 
      @showUpload="showUpload"
      @dirChange="onDirChange" 
    />
    <div class="upload-box" v-if="uploadVisible">
      <div class="titles">
        <span @click="onClickBack">
          <a-icon type="arrow-left" />
        </span>{{ $t("common.material") }}
      </div>
      <div class="contents">
        <!--上傳提示-->
        <div class="upload-state" v-if="uploadState">
          <a-result 
            v-if="stateSuccess" 
            :title="$t('message.uploadSuccess')" 
            status="success"
          >
            <span v-if="reviewInfo">{{ reviewInfo }}</span>
          </a-result>
          <a-spin 
            v-else
            :tip="`${$t('edit.editMessage.createScene')}${sliceProgress}%,${$t('edit.editMessage.noClose')}`">
          </a-spin>
        </div>
        <!--上傳的列表-->
        <drag-uploader 
          uptype="sourceimg" 
          ref="uploader" 
          @updateImagefiles="handleFileChange"
        ></drag-uploader>
      </div>
      <div class="btn-box">
        <a-button 
          :disabled="fileList.length > 0 ? false : true" 
          type="primary" 
          class="ant-btns"
          @click="saveUpFile"
        >
          {{ $t("actionTitles.uploadConfirm") }}
        </a-button>
      </div>
    </div>
    <a-divider />
    <div class="modal-footer">
      <div class="footer-left">
        <a-input
          :addonBefore="`${$t('common.hasSelect')}${count}${$t('form.userDetail.spaceCapacity.existingAccountUnit')}${$t('edit.editMessage.scenes')}`"
          :placeholder="$t('publish.workName.placeholder')" 
          @change="change" 
        />
      </div>
      <a-button 
        type="primary" 
        @click="handleConfirm" 
      >
        {{ $t("actionTitles.ascertain") }}
      </a-button>
    </div>
  </a-modal>
</template>
<script>
import { addPano } from "@/api/material";
import MaterialList from "./components/MaterialList";
import liveList from "./components/liveList";
import PanoramicList from "./components/PanoramicList.vue";
import DragUploader from "../DragUploader";
import SceneList from "./components/SceneList";
import { mapGetters } from "vuex";

export default {
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  components: { MaterialList, DragUploader, PanoramicList, liveList, SceneList },
  data() {
    return {
      count: 0,
      list: [],
      selectedList: [],
      uploadVisible: false,
      uploadState: false,
      stateSuccess: false,
      fileList: [],
      dir_id: 0,
      sliceProgress: 0,
      reviewInfo: "",
      selectScene: null,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    show: {
      get: function () {
        return this.visible;
      },
      set: function () { },
    },
  },
  mounted() { },
  methods: {
    onClickBack() {
      this.quitInitData();
      this.uploadVisible = false;
    },
    quitInitData() {
      this.uploadVisible = false;
      this.stateSuccess = false;
      this.uploadState = false;
      this.fileList = [];
      this.reviewInfo = "";
      this.resetProgress();
    },
    handleSelected(checkList) {
      this.selectedList = [...checkList];
      console.log('this.selectedList:', this.selectedList);
      this.count = this.selectedList.length;
    },
    onClickItem() {
      this.count = this.list.filter((item) => item.selected).length;
    },
    confirm() {
      this.show = false;
    },
    change(e) {
      this.$refs["materialList"].handleSearch(e.target.value);
    },
    // 取消
    handleCancel() {
      this.$emit("close");
    },
    // 保存
    handleConfirm() {
      console.log('handleConfirm的type:', this.type);
      if (this.type == 3) {
        this.$emit("handleConfirmTongPing", this.selectScene);
      } else {
        this.$emit("handleConfirm", this.selectedList);
      }
    },
    showUpload() {
      this.uploadVisible = true;
      console.log("this.fileList", this.fileList);
    },
    handleFileChange(files) {
      this.fileList = files;
    },
    onDirChange(id) {
      this.dir_id = id;
    },
    saveUpFile() {
      this.uploadState = true;
      this.doProgress();
      addPano({
        replace_id: 0,
        imgs: this.fileList.map((p) => {
          return { imgname: p.name, imgsrc: p.key, filesize: p.filesize };
        }),
        dir_id: this.dir_id,
      }).then(() => {
        this.endProgress();
        setTimeout(() => {
          this.$refs.materialList.resetLoad();
          this.stateSuccess = true;
          this.quitInitData();
        }, 1000);
      }).catch((err) => {
        this.reviewInfo = err;
        this.resetProgress();
      });
    },
    resetProgress() {
      this.sliceProgress = 0;
    },
    doProgress() {
      this.progressInterval = setInterval(() => {
        if (this.sliceProgress < 99) {
          this.sliceProgress += 1;
        }
      }, 400);
    },
    endProgress() {
      this.sliceProgress = 100;
      clearInterval(this.progressInterval);
    },
    handleSelectScene(scene) {
      this.selectScene = scene;
      console.log("選擇的場景:", scene)
    },
  },
};
</script>

<style lang="less" scoped>
.modal-content {
  width: 100%;
  max-height: 800px;
  overflow: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.modal-footer {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .sureBtn {
    background-color: #7101ad;
    border-color: #7101ad;
  }
}

@media screen and (max-width: 768px) {
  .footer-left {
    width: 80%;
  }
}

@media screen and (min-width: 768px) {
  .footer-left {
    width: 50%;
  }
}

/* .footer-left {
  width: 50%;
} */
.material-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 33%;
  margin-top: 10px;
}

.item-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
}

.item-img img {
  width: 100%;
}

.item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 11;
  background: #ffffff;
  border-radius: 4px;
  padding: 20px;

  .titles {
    width: 100%;
    font-size: 16px;
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;

    span {
      display: flex;
      width: 34px;
      height: 34px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .contents {
    height: calc(100% - 120px);
    margin-top: 20px;
    overflow: hidden;
    overflow-y: auto;

    .upload-state {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.8);
      z-index: 10;
    }
  }

  .btn-box {
    padding-top: 15px;
    text-align: right;

    .ant-btns {
      height: 38px;
      line-height: 38px;
    }
  }
}
</style>